import { Flex } from '@chakra-ui/react';
import React from 'react';
import { FilterHeading } from 'src/components/atoms/FilterHeading';
import { MenuOpenerButton } from 'src/components/atoms/MenuOpenerButton';
import { FilterBarContainer } from 'src/components/molecules/FilterBarContainer';
import { ClearFiltersButton } from 'src/components/molecules/ClearFiltersButton';
import { LockFiltersButton } from 'src/components/molecules/LockFiltersButton';
import { MediaMenu } from 'src/components/organisms/menus/MediaMenu';
import { TimeRangeSelector } from 'src/components/organisms/TimeRangeSelector';

export const LTFilterBar: React.FC = () => {
  return (
    <FilterBarContainer flexDir="column" py={4}>
      <Flex w="100%" alignItems="center" wrap="wrap">
        {/* Time Range */}
        <Flex direction="column" mr={3} my={2}>
          <FilterHeading headingText="Time Range" color="text.darkGray" />
          <TimeRangeSelector
            includeTimePeriodButtons
            rightElement={<LockFiltersButton filterType="time range" />}
          />
        </Flex>

        {/* Media */}
        <Flex direction="column" alignItems="flex-start" mr={3} my={2}>
          <FilterHeading headingText="Media" color="text.darkGray" />
          <MenuOpenerButton>
            <MediaMenu />
            <LockFiltersButton filterType="media" />
          </MenuOpenerButton>
        </Flex>
      </Flex>

      {/* Clear Filters */}
      <ClearFiltersButton />
    </FilterBarContainer>
  );
};
